import { checkBeforeEnter } from '@/auth/utils';

export default [
    {
        path: '/reports/guarantee-fund',
        name: 'reports-guarantee-fund',
        component: () => import('@/views/modules/reports/GuaranteeFund.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['superadmin', 'admin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Reportes',
            breadcrumb: [{
                text: 'Fondo de garantía',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/reports/cts',
        name: 'reports-cts',
        component: () => import('@/views/modules/reports/ReportCts.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['superadmin', 'admin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Reportes',
            breadcrumb: [{
                text: 'Reporte CTS',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/reports/cts-cartas',
        name: 'reports-cts-cartas',
        component: () => import('@/views/modules/reports/ReportCtsCartas.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['superadmin', 'admin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Reportes',
            breadcrumb: [{
                text: 'Reporte CTS Cartas No Adeudos',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/reports/gratification',
        name: 'reports-gratification',
        component: () => import('@/views/modules/reports/ReportGratification.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['superadmin', 'admin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Reportes',
            breadcrumb: [{
                text: 'Reporte Gratificación',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/reports/gratification-cartas',
        name: 'reports-gratification-cartas',
        component: () => import('@/views/modules/reports/ReportGratificationCartas.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['superadmin', 'admin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Reportes',
            breadcrumb: [{
                text: 'Reporte Gratificación Cartas No Adeudos',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/tools/generate-test-forms',
        name: 'tools-generate-test-forms',
        component: () => import('@/views/modules/tools/GenerateTestForms.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['superadmin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Herramientas',
            breadcrumb: [{
                text: 'Generar Formularios de Prueba',
                active: true
            }],
            requiresAuth: true
        }
    }
]